// Sledování počtu chybějících znaků & autoheight u textarea

export const forumTextarea = (textarea: HTMLTextAreaElement): void => {
  if (!textarea) return;

  const { maxLength } = textarea;
  const counter = textarea.nextElementSibling as HTMLDivElement;

  if (!counter) return;

  // Počítat znaky
  const countChars = (): void => {
    const { value } = textarea;
    const valueLength = value.length;
    const rest = maxLength - valueLength;

    const vysklonujZnaky = (count: number): string => {
      if (count > 4) return 'znaků';
      if (count >= 2 && count <= 4) return 'znaky';
      if (count === 1) return 'znak';
      return 'znaků'; // 0 znaků
    };

    counter.textContent = `${rest.toString()} ${vysklonujZnaky(rest)}`;

    // Přidání třídy pro nízkou hodnotu
    if (rest < 30 && rest > 10) {
      counter.classList.remove('forum__form-remaining--red');
      counter.classList.add('forum__form-remaining--orange');
    } else if (rest <= 10 && rest >= 0) {
      counter.classList.remove('forum__form-remaining--orange');
      counter.classList.add('forum__form-remaining--red');
      textarea.style.borderColor = 'none';
    } else {
      counter.classList.remove('forum__form-remaining--orange');
      counter.classList.remove('forum__form-remaining--red');
    }
  };

  // Auto-resize textarea
  const autoResize = (): void => {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  // Init kvůli otevření modálního okna editace komentáře
  countChars();
  autoResize();

  // Během psaní
  textarea.addEventListener('input', () => {
    countChars();
    autoResize();
  });
};
